import { EmptyMessageView } from "@mibuildweb/components";

export const WorkOrderDrawerHistoryTab = () => {
  return (
    <EmptyMessageView
      title="No History"
      subtitle="There is no prior history to show for this work order."
    />
  );
};
